import { GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST } from "@/components/define/defineType";
import { FeatureType } from "./../define/FeatureType";

/**
 * 一般交通量調査データレイヤ詳細格納クラス
 */
export class GeneralTrafficLayerName {
  /**
   * 一般交通量調査データ表種別
   */
  tableType: FeatureType;

  /**
   * データ種別
   */
  dataType: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST;

  /**
   * 道路種別
   */
  roadCategory: string[];

  /**
   * 時間帯
   */
  specificationTime: string;

  /**
   * コンストラクタ
   * @param tableType
   * @param dataType
   * @param roadCategory
   * @param specificationTime
   */
  constructor(
    tableType: FeatureType,
    dataType: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST,
    roadCategory: string[],
    specificationTime?: string
  ) {
    this.tableType = tableType;
    this.dataType = dataType;
    this.roadCategory = roadCategory;
    this.specificationTime = specificationTime;
  }

  /**
   *一般交通量調査データレイヤ物理名を取得する
   */
  getLayerName(): string {
    return this.tableType;
  }
}
